import React from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

import bannerTop from "../../img/whyus/banner-top.webp";
import bannerCenter from "../../img/whyus/banner-center.webp";
import bannerBottom from "../../img/whyus/banner-bottom.webp";

const ITEMS = ["whyUs.banner.item1", "whyUs.banner.item2", "whyUs.banner.item3"];

function Banner() {
  const { t } = useTranslation();

  return (
    <section className="mt-[80px] lg:mt-[170px]">
      <div className="glcontainer">
        {/* Mobile: одно фото над текстом */}
        <div className="lg:hidden mb-[20px] h-[173px] rounded-[20px] overflow-hidden">
          <img
            src={bannerTop}
            alt=""
            aria-hidden
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[69px] items-start">
          {/* Коллаж (только desktop) */}
          <Fade triggerOnce direction="left" duration={700} className="hidden lg:block w-[51.3%] shrink-0">
          <div className="relative w-full aspect-[626/494]">
            {/* Верх слева */}
            <div className="absolute left-0 top-0 w-[45.7%] h-[57.1%] rounded-[20px] overflow-hidden">
              <img src={bannerTop} alt="" aria-hidden className="w-full h-full object-cover rounded-[20px]" />
            </div>

            {/* Высокая по центру */}
            <div className="absolute left-[49.7%] top-[8.9%] w-[50.3%] h-[78.5%] rounded-[20px] overflow-hidden">
              <img src={bannerCenter} alt="" aria-hidden className="w-full h-full object-cover rounded-[20px]" />
            </div>

            {/* Низ слева */}
            <div className="absolute left-0 top-[62.1%] w-[45.7%] h-[37.9%] rounded-[20px] overflow-hidden">
              <img
                src={bannerBottom}
                alt=""
                aria-hidden
                className="w-full h-full object-cover rounded-[20px]"
              />
            </div>
          </div>
          </Fade>

          {/* Контент справа */}
          <div className="flex flex-col flex-1 w-full lg:pt-[44px]">
            <SectionTitle
              title1={t("whyUs.banner.title1")}
              title2={t("whyUs.banner.title2")}
              text={t("whyUs.banner.subtitle")}
              align="left"
              className="max-w-[525px] [&>p]:max-w-none"
            />

            <p className="mt-[15px] font-['Inter'] font-bold text-[16px] leading-[1.5] text-[#435c7f] max-w-[525px]">
              {t("whyUs.banner.tagline")}
            </p>

            <ul className="mt-[15px] grid grid-cols-2 lg:grid-cols-1 gap-x-[28px] gap-y-[12px] lg:gap-y-[15px] max-w-[525px]">
              <Fade cascade triggerOnce direction="up" damping={0.06}>
                {ITEMS.map((key) => (
                  <li
                    key={key}
                    className="font-['Inter'] font-bold text-[14px] lg:text-[16px] leading-[1.5] text-[#435c7f] list-disc ml-[20px] lg:ml-[24px]"
                  >
                    {t(key)}
                  </li>
                ))}
              </Fade>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
